module.exports = __webpack_public_path__ + "static/media/niharikha.58179151.JPG";